<!-- 编辑询价单 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="search-ctn">
      <div class="search-ctn-left">
        <div class="search-name">期限日期:</div>
        <el-date-picker
          :disabled="type == 1"
          value-format="yyyy-MM-dd"
          class="search-item"
          size="small"
          v-model="submitData.NeedTime"
          type="date"
        ></el-date-picker>
        <div class="search-name">备注:</div>
        <el-input
          :readonly="type == 1"
          style="width: 300px"
          class="search-item"
          size="small"
          v-model.trim="submitData.Remark"
        ></el-input>
      </div>
    </div>
    <div class="div-table-row table-title">
      <div class="div-table-cell" style="width: 10%">图片</div>
      <div class="div-table-cell" style="width: 20%">汽配编码</div>
      <div class="div-table-cell" style="width: 20%">
        <span class="color-red">*</span>名称
      </div>
      <div class="div-table-cell" style="width: 15%">
        <span class="color-red">*</span>车系
      </div>
      <div class="div-table-cell" style="width: 5%">数量</div>
      <div class="div-table-cell" style="width: 15%">汽配品牌</div>
      <div class="div-table-cell" style="width: 5%">
        <span class="color-red">*</span>单位
      </div>
      <div class="div-table-cell" style="width: 5%">价格</div>
      <div class="div-table-cell" style="width: 5%">合计</div>
    </div>
    <!--    查看    -->
    <div v-if="type == 1">
      <div class="table-main">
        <div class="div-table-row table-item" v-for="(item,index) in dataList" v-bind:key="index">
          <div class="div-table-cell" style="width: 10%">
            <div class="image-ctn" style="width: 70px;height: 70px">
              <img :src="download_url + item.PartPictureList[0]" alt />
            </div>
          </div>
          <div class="div-table-cell" style="width: 20%">
            <el-tooltip effect="dark" :content="item.GoodsCode" placement="top">
              <span>{{item.GoodsCode}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 20%">
            <el-tooltip effect="dark" :content="item.GoodsName" placement="top">
              <span>{{item.GoodsName}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 15%">
            <el-tooltip effect="dark" :content="item.AutoSerieName" placement="top">
              <span>{{item.AutoSerieName}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 5%">
            <el-tooltip effect="dark" :content="item.Count.toString()" placement="top">
              <span>{{item.Count}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 15%">
            <el-tooltip effect="dark" :content="item.BrandName" placement="top">
              <span>{{item.BrandName}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 5%">{{item.Unit}}</div>
          <div class="div-table-cell" style="width: 5%">
            <el-tooltip effect="dark" :content="item.Price.toString()" placement="top">
              <span>{{item.Price}}</span>
            </el-tooltip>
          </div>
          <div class="div-table-cell" style="width: 5%">
            <el-tooltip effect="dark" :content="(item.Count*item.Price).toString()" placement="top">
              <span>{{item.Count*item.Price}}</span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!--    新增编辑    -->
    <div v-else class="edit-ctn">
      <div class="table-main">
        <div class="div-table-row table-item" v-for="(item,index) in dataList" v-bind:key="index">
          <!--        图片            -->
          <div class="div-table-cell" style="width: 11.11%" @click="showUpload(item,index)">
            <div class="image-ctn" v-if="item.PartPictureList[0]" style="width: 70px;height: 70px">
              <img :src="download_url + item.PartPictureList[0]" alt />
            </div>
            <div class="image-btn" v-else>
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <!--        编码            -->
          <div class="div-table-cell" style="width: 11.11%">
            <el-select
              :loading="loading"
              allow-create
              clearable
              default-first-option
              size="small"
              v-model="item.GoodsCode"
              value-key="GoodCode"
              filterable
              remote
              reserve-keyword
              placeholder="汽配编码"
              @change="codeChange($event,index)"
              :remote-method="searchCode"
            >
              <el-option
                v-for="optionItem in codeList"
                :key="optionItem.GoodCode"
                :data-msg="optionItem"
                :label="optionItem.GoodCode"
                :value="optionItem.GoodCode"
              >
                <div class="option-content">
                  <div style="width: 200px">{{optionItem.GoodCode}}</div>
                  <div>{{optionItem.GoodName}}</div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!--        名称            -->
          <div class="div-table-cell" style="width: 11.11%">
            <el-select
              :loading="loading"
              allow-create
              size="small"
              v-model="item.GoodsName"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="配件名称"
              @change="nameChange($event,index)"
              :remote-method="searchName"
            >
              <el-option
                v-for="optionItem in nameList"
                :key="optionItem.GoodCode"
                :data-msg="optionItem"
                :label="optionItem.GoodName"
                :value="optionItem.GoodName"
              >
                <div class="option-content">
                  <div style="width: 200px">{{optionItem.GoodCode}}</div>
                  <div>{{optionItem.GoodName}}</div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!--        车系            -->
          <div class="div-table-cell" style="width: 11.11%">
            <el-select
              :loading="loading"
              allow-create
              size="small"
              v-model="item.AutoSerieName"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="车系"
              :remote-method="searchAutoSerie"
            >
              <el-option
                :loading="true"
                v-for="item in seriesList"
                :key="item.SeriesId"
                :label="item.SeriesName"
                :value="item.SeriesName"
              ></el-option>
            </el-select>
          </div>
          <!--        数量            -->
          <div class="div-table-cell" style="width: 11.11%">
            <inputNumber :index="index" :data="{BuyCount:item.Count}" @change="handleNumChange"></inputNumber>
          </div>
          <!--        品牌           -->
          <div class="div-table-cell" style="width: 11.11%">
            <el-select
              :loading="loading"
              allow-create
              size="small"
              v-model="item.BrandName"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="汽配品牌"
              :remote-method="searchBrand"
            >
              <el-option
                :loading="true"
                v-for="item in brandList"
                :key="item.BrandId"
                :label="item.BrandName"
                :value="item.BrandName"
              ></el-option>
            </el-select>
          </div>
          <!--        单位         -->
          <div class="div-table-cell" style="width: 11.11%">
            <el-select
              allow-create
              default-first-option
              size="small"
              v-model="item.Unit"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="单位"
            >
              <el-option
                v-for="optionItem in unitList"
                :key="optionItem.Value"
                :data-msg="optionItem.Value"
                :label="optionItem.Value"
                :value="optionItem.Value"
              ></el-option>
            </el-select>
          </div>
          <div class="div-table-cell" style="width: 11.11%">-</div>
          <div class="div-table-cell" style="width: 11.11%">-</div>
          <el-button class="less-btn" icon="el-icon-minus" circle @click="delItem(index)"></el-button>
        </div>
        <el-button class="add-btn" type="primary" icon="el-icon-plus" circle @click="addItem"></el-button>
      </div>
      <div class="btn-ctn">
        <el-button
          size="small"
          class="search-btn btn-primary"
          @click="submitForm(false)"
          v-if="permission.save"
        >保存</el-button>
        <el-button
          size="small"
          class="search-btn btn-primary"
          @click="submitForm(true)"
          v-if="permission.submit"
        >提交询价</el-button>
      </div>
    </div>
    <el-dialog title="上传配件图片" :visible.sync="dialogVisible" width="800px">
      <div v-if="dialogVisible">
        <uploadCover @save="save" :index="uploadIndex" :uploadUrl="uploadUrl"></uploadCover>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import inputNumber from "@/components/common/inputNumber";
import uploadCover from "@/components/business/goods/uploadCover";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    inputNumber,
    uploadCover,
    breadcrumb
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      permission: {},
      needConfirm: true,
      NeedRefresh: "true", // 列表页是否需要刷新
      canRequest: true,
      loading: false,
      browseId: "",
      submitData: {
        InquiryBillId: "", // 询价单id
        UserId: userMsg.EmployeeId,
        NeedTime: "",
        Remark: "",
        IsSubmitReview: false,
        DetailList: []
      },
      Limit: 10,
      download_url: this.$util.QN_URL_BASE,
      uploadIndex: -1,
      uploadUrl: [],
      dialogVisible: false,
      dataList: [],
      codeList: [],
      nameList: [],
      seriesList: [],
      brandList: [],
      unitList: ["件", "个", "片", "只", "台", "升", "毫升", "箱", "包"],
      type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
      id: "",
      pageTitle: ""
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$util.confirmBeforeLeave(to, from, next, this);
  },
  mounted() {
    this.id = this.$route.query.id;
    this.browseId = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.type == 1) {
      this.pageTitle = "查看询价单";
      this.NeedRefresh = null;
      this.getRfq();
    } else if (this.type == 2) {
      this.pageTitle = "编辑询价单";
      this.getRfq();
    } else if (this.type == 3) {
      this.pageTitle = "新增询价单";
      this.addItem();
    } else if (this.type == 4) {
      this.pageTitle = "快速创建询价单";
      this.getRfq();
    }
    this.getDic();
  },
  methods: {
    async getDic() {
      await this.searchCode();
      await this.searchName();
      await this.searchAutoSerie();
      await this.searchBrand();
      this.permission = this.$util.getPermission("rfq");
    },
    // 如果是查看获取询价单详情
    getRfq() {
      this.$util
        .axiosGet({
          url: "/api/InquiryOrder/GetInquiryOrder",
          data: {
            InquiryBillId: this.id,
            EntpId: this.userMsg.EntpId
          }
        })
        .then(res => {
          if (this.type != 4) {
            res.data.InquiryBillId = this.id;
          }
          res.data.UserId = this.userMsg.EmployeeId;
          this.submitData = res.data;
          this.dataList = res.data.DetailList;
        });
    },
    // 提交询价单
    submitForm(isSubmitReview) {
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].GoodsName) {
          this.$util.warningMsg("配件名称不能为空");
          return;
        }
        if (!_dataList[i].AutoSerieName) {
          this.$util.warningMsg("车系不能为空");
          return;
        }
        if (!_dataList[i].Unit) {
          this.$util.warningMsg("单位不能为空");
          return;
        }
      }
      this.submitData.isSubmitReview = isSubmitReview;
      this.submitData.DetailList = _dataList;
      if (!this.canRequest) {
        return;
      }
      this.canRequest = false;
      this.$util
        .axiosPost({
          url: "/api/InquiryOrder/SaveInquiryOrder",
          data: this.submitData
        })
        .then(() => {
          if (isSubmitReview) {
            this.$util.successMsg("提交询价单成功");
          } else {
            this.$util.successMsg("保存询价单成功");
          }
          setTimeout(() => {
            this.canRequest = true;
            this.needConfirm = false;
            this.$router.push("/business/purchaseManage/rfq");
          }, 2000);
        })
        .catch(() => {
          this.canRequest = true;
        });
    },
    // 保存图片
    save(imgList, index) {
      this.uploadUrl = [];
      if (imgList) {
        this.dataList[index].PartPictureList = imgList;
      }
      this.dialogVisible = false;
    },
    // 显示图片上传
    showUpload(item, index) {
      if (item.PartPictureList[0]) {
        this.uploadUrl = item.PartPictureList;
      }
      this.uploadIndex = index;
      this.dialogVisible = true;
    },
    // 删除某行
    delItem(index) {
      if (this.dataList.length != 1) {
        this.dataList.splice(index, 1);
      }
    },
    // 添加一行
    addItem() {
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].GoodsName) {
          this.$util.warningMsg("请填写配件名称");
          return;
        }
        if (!_dataList[i].AutoSerieName) {
          this.$util.warningMsg("请填写车系");
          return;
        }
        if (!_dataList[i].Unit) {
          this.$util.warningMsg("请填写单位");
          return;
        }
      }
      this.dataList.push({
        PartPictureList: [],
        GoodsCode: "",
        GoodsName: "",
        AutoSerieName: "",
        BrandName: "",
        Count: "1",
        Price: "0",
        allPrice: "",
        Unit: ""
      });
    },
    // 搜品牌
    searchBrand(key) {
      this.loading = true;
      return new Promise(resolve => {
        this.$util
          .axiosGet({
            url: "/api/InquiryOrder/GetBrandList",
            data: {
              BrandName: key,
              Limit: this.Limit
            },
            hideLoading: true
          })
          .then(res => {
            this.brandList = res.data;
            this.loading = false;
            resolve();
          });
      });
    },
    // 改变商品数量
    handleNumChange(data, value, index) {
      this.dataList[index].Count = value;
    },
    // 搜车系
    searchAutoSerie(key) {
      this.loading = true;
      return new Promise(resolve => {
        this.$util
          .axiosGet({
            url: "/api/InquiryOrder/GetVehicleSeriesList",
            data: {
              SeriesName: key,
              Limit: this.Limit
            },
            hideLoading: true
          })
          .then(res => {
            this.loading = false;
            this.seriesList = res.data;
            resolve();
          });
      });
    },
    // 名称改变
    nameChange(value, index) {
      let target = this.dataList[index];
      let _list = this.nameList;
      if (target.GoodsCode) {
        return;
      }
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].GoodName == value) {
          target.GoodsCode = _list[i].GoodCode;
          if (_list[i].MainImg) {
            target.PartPictureList.push(_list[i].MainImg);
          }
        }
      }
    },
    // 搜索名称
    searchName(key) {
      this.loading = true;
      return new Promise(resolve => {
        this.$util
          .axiosGet({
            url: "/api/InquiryOrder/GetPartList",
            data: {
              GoodName: key,
              Limit: this.Limit,
              EntpId: this.userMsg.EntpId
            },
            hideLoading: true
          })
          .then(res => {
            this.loading = false;
            this.nameList = res.data;
            resolve();
          });
      });
    },
    // 编码改变
    codeChange(value, index) {
      let target = this.dataList[index];
      let _list = this.codeList;
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].GoodCode == value) {
          target.GoodsName = _list[i].GoodName;
          if (_list[i].MainImg) {
            target.PartPictureList.push(_list[i].MainImg);
          }
          break;
        }
      }
    },
    // 搜索汽配编码
    searchCode(key) {
      this.loading = true;
      return new Promise(resolve => {
        this.$util
          .axiosGet({
            url: "/api/InquiryOrder/GetPartList",
            data: {
              GoodCode: key,
              Limit: this.Limit,
              EntpId: this.userMsg.EntpId
            },
            hideLoading: true
          })
          .then(res => {
            this.loading = false;
            this.codeList = res.data;
            resolve();
          });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.edit-ctn {
  .div-table-cell {
    padding: 0 5px;
  }
}
.search-ctn-left {
  display: flex;
  align-items: center;
  .search-name {
    margin: 0 10px 10px 10px;
  }
}
.option-content {
  display: flex;
  line-height: 30px;
}
.btn-ctn {
  padding-top: 30px;
  margin-right: 110px;
  text-align: right;
}
.add-btn {
  position: absolute;
  right: -40px;
  bottom: 0;
}
.less-btn {
  position: absolute;
  right: -40px;
  top: 0;
  z-index: 2;
}
.business-content-main {
  padding-right: 80px;
}
.table-main {
  position: relative;
}
.image-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border: 1px dashed @border3Color;
}
.table-title {
  line-height: 36px;
  text-align: center;
  font-weight: bold;
}
.div-table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.table-item {
  height: 80px;
  position: relative;
}
.div-table-row {
  overflow: inherit;
}
</style>
